import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute from '@/layout/components/PrivateRoute'
import ExpertPrivateRoute from '@/layout/components/ExpertPrivateRoute'
import { Profile } from '@/features/farmer/domain/farmer-interface'
import {
  LazeMapPolygonView,
  LazyChillingRequirements,
  LazyColleagueAccessConfigs,
  LazyCounter,
  LazyCultivarRecommendation,
  LazyExperts,
  LazyFarmacounting,
  LazyFarmerFields,
  LazyFarmerSwitchForExpert,
  LazyFieldCertificate,
  LazyFinancial,
  LazyFirstSaffronIrrigation,
  LazyHarvestDate,
  LazyLaboratory,
  LazyLaboratoryReports,
  LazyAgriculturalMarket,
  LazyMeeto,
  LazyNutritionProgram,
  LazyOperations,
  LazyWalletPayment,
  Lazyincreasebalance,
  LazySowingDates,
  LazyVisitReports,
  LazyVisits,
  LazyWaterCertificate,
  LazyWaterSources,
  LazyWeatherStation,
  LazyWeatherStationPage,
  LazyWeedManagement,
  LazyYieldGaps,
  LazyMyMechanization,
  LazyMechanizationCertification,
  LazyIotPanelMap,
  LazyCroppingPattern,
  LazyCroppingSuitability,
  LazyFarmerProfile,
  LazyMechanizationIotPanel,
  LazyWaterSourceIotPanel,
  LazyAgriculturalInputInquiry,
  LazyAgriculturalInputOrder,
  LazyAgriculturalInputPurchasingPayment
} from '@/layout/utils/lazy-loader'
// @ts-ignore
import AgroyaarLoading from '../../gif/Ripple-1s-200px.gif'

interface NavigationProps {
  profile: Profile
}

const Navigation = ({ profile }: NavigationProps) => {
  // const location = useLocation();
  // const newFarmerId = location?.state?.farmerId;

  // const profileQuery = useQuery({
  //   queryKey: ["farmerProfile", newFarmerId],
  //   queryFn: () => getFarmerProfile(newFarmerId),
  //   cacheTime: 0,
  // });

  // if (profileQuery.isSuccess) {
  // // const newProfile = JSON.stringify(profileQuery?.data?.farmer);
  // // localStorage.setItem("profile", newProfile);
  // }

  return (
    <div className='p-1'>
      <Routes>
        <Route
          path='/'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyCounter />
            </React.Suspense>
          }
        />

        <Route
          element={<PrivateRoute access={profile.access} route={'FARMS'} />}
        >
          <Route
            path='/my-fields'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:mt-0'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFarmerFields />
              </React.Suspense>
            }
          />
          <Route
            path='my-fields/field_certificate/:id'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFieldCertificate />
              </React.Suspense>
            }
          />
          <Route
            path='my-fields/map'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazeMapPolygonView />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'IRRIGATION_SOURCES'}
            />
          }
        >
          <Route
            path='/my-water-sources'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:mt-0'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyWaterSources />
              </React.Suspense>
            }
          />
          <Route
            path='my-water-sources/water_certificate/:id'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyWaterCertificate />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'WEATHER_STATIONS'} />
          }
        >
          <Route
            path='/weather-station'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyWeatherStation />
              </React.Suspense>
            }
          />

          <Route
            path='/weather-station/:id'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyWeatherStationPage />
              </React.Suspense>
            }
          />
        </Route>

        <Route
          path='/mechanization'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyMyMechanization />
            </React.Suspense>
          }
        />

        <Route
          path='/mechanization/:id'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyMechanizationCertification />
            </React.Suspense>
          }
        />

        <Route
          path='/iot-panel/:id'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyMechanizationIotPanel />
            </React.Suspense>
          }
        >
          <Route
            path='/iot-panel/:id/live-map'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyIotPanelMap />
              </React.Suspense>
            }
          />
        </Route>

        <Route
          path='/iot-panel/water-source/:id'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyWaterSourceIotPanel />
            </React.Suspense>
          }
        />

        <Route
          element={<PrivateRoute access={profile.access} route={'VISITS'} />}
        >
          <Route
            path='/visit'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyVisits />
              </React.Suspense>
            }
          />
          <Route
            path='/visit-reports'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyVisitReports />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'OPERATIONS'} />
          }
        >
          <Route
            path='/operations'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyOperations />
              </React.Suspense>
            }
          />
          <Route
            path='/visit-reports'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyVisitReports />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'EXPERIMENTS'} />
          }
        >
          <Route
            path='/laboratory'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyLaboratory />
              </React.Suspense>
            }
          />

          <Route
            path='/laboratory-reports'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyLaboratoryReports />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'QUESTIONNAIRES'} />
          }
        >
          <Route
            path='/nutrition-program'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyNutritionProgram />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'CHILLING_REQUIREMENTS'}
            />
          }
        >
          <Route
            path='/chilling-requirement'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyChillingRequirements />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'CULTIVAR_RECOMMENDATIONS'}
            />
          }
        >
          <Route
            path='/cultivar-recommendation'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img
                      src={AgroyaarLoading}
                      alt='fallback'
                      className='bg-orange-700'
                    />
                  </div>
                }
              >
                <LazyCultivarRecommendation />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'HARVEST_DATE_RECOMMENDATIONS'}
            />
          }
        >
          <Route
            path='/harvest-recommendation'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyHarvestDate />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'YIELD_GAPS'} />
          }
        >
          <Route
            path='/yield-gaps'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyYieldGaps />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'SOWING_DATE_RECOMMENDATIONS'}
            />
          }
        >
          <Route
            path='/sowing-date'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazySowingDates />
              </React.Suspense>
            }
          />
        </Route>
        {/* <Route
          element={
            <PrivateRoute access={profile.access} route={"PRESCRIPTIONS"} />
          }
        > */}
        <Route
          path='/weed-management'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyWeedManagement />
            </React.Suspense>
          }
        />
        <Route
          path='/cropping-pattern'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyCroppingPattern />
            </React.Suspense>
          }
        />
        <Route
          path='/cropping-suitability'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyCroppingSuitability />
            </React.Suspense>
          }
        />
        {/* </Route> */}
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'PLANTING_DENSITIES'}
            />
          }
        ></Route>
        <Route
          element={
            <PrivateRoute
              access={profile.access}
              route={'FIRST_SAFFRON_IRRIGATION_DATE_RECOMMENDATIONS'}
            />
          }
        >
          <Route
            path='first-saffron-irrigation'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFirstSaffronIrrigation />
              </React.Suspense>
            }
          />
        </Route>

        <Route
          path='agricultural-market'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyAgriculturalMarket />
            </React.Suspense>
          }
        />

        <Route
          path='/agricultural-market/agricultural-input-purchasing/inquiry'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyAgriculturalInputInquiry />
            </React.Suspense>
          }
        />

        <Route
          path='/agricultural-market/agricultural-input-purchasing/order'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyAgriculturalInputOrder />
            </React.Suspense>
          }
        />

        <Route
          path='/agricultural-market/agricultural-input-purchasing/order/:id/payment/'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyAgriculturalInputPurchasingPayment />
            </React.Suspense>
          }
        />

        <Route
          path='knowledge-sharing-network'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyMeeto />
            </React.Suspense>
          }
        />

        <Route
          path='farm-accounting'
          element={
            <React.Suspense
              fallback={
                <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:'>
                  <img src={AgroyaarLoading} alt='fallback' />
                </div>
              }
            >
              <LazyFarmacounting />
            </React.Suspense>
          }
        />

        <Route
          element={<PrivateRoute access={profile.access} route={'INVOICES'} />}
        >
          <Route
            path='/financial-management'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFinancial />
              </React.Suspense>
            }
          />
          <Route
            path='payment/:id'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyWalletPayment />
              </React.Suspense>
            }
          ></Route>

          <Route
            path='financial-management/increase-balance'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <Lazyincreasebalance />
              </React.Suspense>
            }
          ></Route>
        </Route>
        <Route
          element={
            <PrivateRoute access={profile.access} route={'EXPERT_ACCESS'} />
          }
        >
          <Route
            path='/my-colleagues'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:mt-0'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyExperts />
              </React.Suspense>
            }
          />
          <Route
            path='/my-colleagues/:id'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:mt-0'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyColleagueAccessConfigs />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<ExpertPrivateRoute />}>
          <Route
            path='/switchUser'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl max-lg:mt-0'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFarmerSwitchForExpert />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          element={<PrivateRoute access={profile.access} route={'FARMERS'} />}
        >
          <Route
            path='/profile'
            element={
              <React.Suspense
                fallback={
                  <div className='h-[100vh] mt-60 mr-96 text-8xl'>
                    <img src={AgroyaarLoading} alt='fallback' />
                  </div>
                }
              >
                <LazyFarmerProfile />
              </React.Suspense>
            }
          />
        </Route>
      </Routes>
    </div>
  )
}

export default Navigation
